import Icon from '@mui/icons-material/ChatBubbleOutlineRounded'
import { ReferenceField } from 'react-admin'

export default {
  name: 'incident-report-comments',
  recordRepresentation: (record) => <ReferenceField reference="incident-reports" source="incident_report_id" />,
  options: {
    defaultSort: { field: 'created_on', order: 'DESC' },
  },
  icon: Icon,
  showResource: 'incident-reports',
}
